// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { getProp } from "@insite/mobius/utilities";
import Trash from "@keller/XDL/Icons/Trash";
import { color, xScreen } from "@keller/XDL/Utilities";
import { pageTitleStyle } from "@keller/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

configureBudgetStyles.titleText = pageTitleStyle;

configureBudgetStyles.titleGridItems = {
    width: [12, 12, 8, 8, 8],
    css: css`
        display: flex;
        align-items: center;
    `,
};

configureBudgetStyles.cancelButton = {
    variant: "secondary",
    css: css`
        order: 1;
        margin-left: 10px;
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-left: 0;
            margin-top: 10px;
        }
    `,
};

configureBudgetStyles.saveButton = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 50%;
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

configureBudgetStyles.removeIcon = {
    src: Trash,
    size: 16,
    css: css`
        display: block;
        cursor: pointer;
        margin: auto;
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

        &:hover {
            color: ${color("danger")};
        }
    `,
};

configureBudgetStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        display: flex;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
        & > div {
            display: flex;
            width: 100%;
            ${xScreen("lte", "xs")} {
                flex-wrap: wrap;
            }
            ${xScreen("gt", "sm")} {
                display: none;
            }
        }
    `,
};

configureBudgetStyles.budgetPeriodTitle = {
    variant: "h5",
    css: css`
        display: inline-block;
        margin-right: 6px;
        + span {
            height: 100%;
            line-height: 2.1 !important;
        }
    `,
};

configureBudgetStyles.gridItems = {
    width: [12, 12, 12, 6, 6],
};

configureBudgetStyles.enforcementLevelGridItems = {
    width: 12,
    css: css`
        display: block;
        & > div {
            display: flex;
            align-items: flex-start;
        }
        .tooltip-container {
            margin-top: 4px;
        }
    `,
};

configureBudgetStyles.gridItems = {
    css: css`
        .tooltip-container {
            margin-top: -4px;
        }
    `,
};

configureBudgetStyles.removeCells = {
    css: css`
        cursor: auto;
    `,
};
